export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Hoodie_Roughness.ced9adb3.tga";